export default "__VITE_ASSET__CPh3BHBX__"